import React, { useEffect, useState } from "react";
import About from "../components/About";
import Slider from "../components/Slider";
import Footer from "../components/commons/footer";
import Agenda from "../components/Agenda";
import Speakers from "../components/Speakers";
import Posteos from "../components/Posteos";
import Container from "react-bootstrap/Container";
import axios from "axios";
import Header from "../components/commons/header";
import Loading from "../components/LoadingCard";

//import Loading from "../components/LoadingCard";

function Home() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [dataId, setDataId] = useState([]);
  const [dataAsistentes, setDataAsistentes] = useState([]);
  const [dataPosteos, setDataPosteos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://api.airtable.com/v0/appU9oJNtiwOW7ThW/tblQZpFVXD63O5fGD?fields%5B%5D=ID&fields%5B%5D=dia&fields%5B%5D=hora&fields%5B%5D=titulo_agenda&fields%5B%5D=descripcion&fields%5B%5D=titulo_agenda_en&fields%5B%5D=descripcion_en&maxRecords=25&pageSize=25&sort%5B0%5D%5Bfield%5D=ID&sort%5B0%5D%5Bdirection%5D=asc`,
          {
            headers: {
              Authorization:
                "Bearer " +
                "pat25UgDRUWSwtHdn.909018692be8be625622df360bf42236e022f2004baeb34d29626bf2ee5185c5",
              "Content-Type": "application/json",
            },
          }
        );
        const res = response.data.records.map((el) => el.fields);
        setData(res);
      } catch (error) {
        console.error(error.message);
      }
      try {
        const response = await axios.get(
          `https://api.airtable.com/v0/appU9oJNtiwOW7ThW/tbl1qUzkaMJaFqtRY?fields%5B%5D=nombre&fields%5B%5D=perfil&fields%5B%5D=perfil_en&fields%5B%5D=url_img&maxRecords=90&pageSize=90&sort%5B0%5D%5Bfield%5D=nombre&sort%5B0%5D%5Bdirection%5D=asc`,
          {
            headers: {
              Authorization: "Bearer " + "pat25UgDRUWSwtHdn.909018692be8be625622df360bf42236e022f2004baeb34d29626bf2ee5185c5",
              "Content-Type": "application/json",
            },
          }
        );
        const res = response.data.records.map((el) => el.fields);
        setDataAsistentes(res);
      } catch (error) {
        console.error(error.message);
      }

      try {
        const response = await axios.get(
          `https://api.airtable.com/v0/appU9oJNtiwOW7ThW/posteos`,
          {
            headers: {
              Authorization:
                "Bearer " +
                "pat25UgDRUWSwtHdn.909018692be8be625622df360bf42236e022f2004baeb34d29626bf2ee5185c5",
              "Content-Type": "application/json",
            },
          }
        );
        const res = response.data.records.map((el) => el.fields);
        setDataPosteos(res);
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <>
      <Container fluid={true}>
        <Header />
        {!loading ? (
          <>
            <About />
            <Agenda data={data} />
            <Speakers deviceType={"desktop"} data={dataAsistentes} />
            <Posteos data={dataPosteos} />
            <Slider />
            <Footer />
          </>
        ) : (
          <Loading />
        )}
      </Container>
    </>
  );
}

export default Home;
